import { useContext } from 'react';
import { Context } from '../../common/js/context';
import { Lang } from '../../common/js/i18n';

export default function LangSwitch() {
    let context = useContext(Context);
    return (
        <select value={context.lang} onChange={(evt) => {
            context.setLang(evt.target.value as any);
        }}>
            <option value={Lang.En}>English</option>
            <option value={Lang.Zh}>中文</option>
        </select>
    );
}
